/**
 * Footer and richtext blocks use hardcoded /policies/... URLs. On translated
 * storefronts (e.g. /en/) those paths resolve to the default locale policy.
 */
function localizePolicyLinks() {
    const root =
        (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ||
        (window.Theme && window.Theme.routes && window.Theme.routes.root) ||
        "/";

    if (!root || root === "/") return;

    const prefix = root.endsWith("/") ? root.slice(0, -1) : root;

    document.querySelectorAll('a[href^="/policies/"]').forEach((anchor) => {
        const href = anchor.getAttribute("href");
        if (!href || href.startsWith(prefix + "/")) return;
        anchor.setAttribute("href", prefix + href);
    });
}

document.addEventListener("DOMContentLoaded", () => {
    localizePolicyLinks();

    function moveWishlistButton() {
        const wishlist = document.querySelector("#wishlisthero-product-page-button-container");
        const buttons = document.querySelector(".product-form-buttons");

        if (!wishlist || !buttons) return;

        if (!buttons.contains(wishlist)) {
            buttons.insertBefore(wishlist, buttons.firstChild);
        }
    }

    moveWishlistButton();

    new MutationObserver(moveWishlistButton).observe(document.body, {
        childList: true,
        subtree: true
    });

});

document.addEventListener("shopify:section:load", localizePolicyLinks);